(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltListController', OltListController);

    OltListController.$inject = ['$scope', 'OltData', 'OltService'];

    function OltListController($scope, OltData, OltService) {

        var vm = this;
        var oltParent = $scope.$parent;

        vm.data = OltData;
        vm.list = {};
        vm.view = {};
        vm.list.checkBoxEnable = false;
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.singlePanel = false;
        vm.view.manyDataPanel = false;
        vm.view.menuSelectAll = 'disable';
        vm.view.menuSelectIndividual = 'disable';
        vm.view.menuSelection = false;

        oltParent.panelIsVisible = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'name'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-name'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];

        vm.clickOltItem = function (olt) {

            //OltService.waitModalConstructor(true);
            // Event olt item
            // if return true will open the olt detail, otherwise checkbox will enable/disable
            if (menuSelectionIsDisable(olt)) {
                if (vm.data.detail) {
                    if (vm.data.detail.id == olt.id && vm.view.singlePanel) {
                        vm.hidePanel();
                        vm.data.detail = null;
                        olt.active = false;
                        return;
                    }
                }

                OltData.setDetail({
                    id: olt.id,
                    name: olt.name,
                    onLine: olt.onLine,
                    mostCriticalAlarm: olt.mostCriticalAlarm
                });

                vm.showPanel();
                vm.unselectAll();
                markAsActive(olt.id);
                vm.view.singlePanel = true;
                vm.list.checkBoxEnable = false;

                //OltService.waitModalConstructor(false);

            }
        }

        $scope.$on('requestsCanceled', closeDetail);
        $scope.$on('oltDelete', closeDetail);
        $scope.$on('oltSearch', closeDetail);

        function closeDetail() {
            vm.hidePanel();
            vm.unselectAll();
            vm.data.detail = null;
            vm.view.singlePanel = false;
            vm.view.manyDataPanel = false;
            vm.list.checkBoxEnable = false;
            vm.toggleMenuActive(false);
        }

        // Mark only the current open olt as active on the list
        function markAsActive(id) {
            vm.data.arrayOlts.forEach(function (item) {
                item.active = item.id == id;
            });
        }

        vm.setTypeOrder = function (type) {
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        vm.typeSelection = function (typeSelection) {
            vm.list.checkBoxEnable = true;
            if (vm.view.singlePanel) {
                vm.data.selected = [];
                vm.data.detail = null;
                markAsActive('');
            }
            switch (typeSelection) {
                case 'selectAll':
                    if (checkStatusOption(vm.view.isActiveOptionAll)) {
                        vm.toggleMenuActive(false);
                        vm.view.menuSelection = false;
                        return;
                    }
                    vm.selectAll();
                    vm.showPanel();
                    vm.toggleMenuActive('selectAll');
                    break;
                case 'selectIndividual':
                    if (checkStatusOption(vm.view.isActiveOptionIndividual)) {
                        vm.toggleMenuActive(false);
                        vm.view.menuSelection = false;
                        return;
                    }
                    vm.selectIndividual();
                    vm.toggleMenuActive('selectIndividual');
                    break;
            }
        }

        vm.addAndRemoveItem = function (item) {
            if (vm.view.singlePanel) {
                vm.data.selected = [];
            }
            if (item.selected) {
                vm.data.selected.push(item);
                OltData.triggerItemSelected();
                vm.showPanel();
            } else {
                angular.forEach(vm.data.selected, function (itemDetail, index) {
                    if (!item.selected && itemDetail.id == item.id) {
                        vm.data.selected.splice(index, 1);
                        OltData.triggerItemSelected();
                    }
                });
                if (vm.data.selected.length == 0) {
                    vm.hidePanel();
                }
            }
        }

        vm.selectAll = function () {
            vm.data.selected = [];
            vm.view.singlePanel = false;
            vm.view.menuSelection = true;
            angular.forEach(vm.data.arrayOlts, function (oltItem) {
                oltItem.selected = true;
                vm.data.selected.push({
                    id: oltItem.id,
                    name: oltItem.name,
                    mostCriticalAlarm: oltItem.mostCriticalAlarm,
                    selected: true
                });
            });
            OltData.triggerItemSelected();
        };

        vm.selectIndividual = function () {
            vm.unselectAll();
            vm.data.selected = [];
            vm.view.singlePanel = false;
            vm.view.menuSelection = true;
            if (vm.data.selected.length == 0) {
                vm.hidePanel();
            }
        }

        vm.unselectAll = function () {
            vm.data.selected = [];
            angular.forEach(vm.data.arrayOlts, function (oltItem) {
                oltItem.selected = false;
            });
            vm.view.menuSelection = false;
        }

        vm.showPanel = function () {
            oltParent.panelIsVisible = true;
        }

        vm.hidePanel = function () {
            oltParent.panelIsVisible = false;
        }

        vm.toggleMenuActive = function (option) {
            if (option) {
                if (option == 'selectAll') {
                    vm.view.isActiveOptionAll = true;
                    vm.view.isActiveOptionIndividual = false;
                    vm.view.menuSelectAll = 'enable';
                    vm.view.menuSelectIndividual = 'disable';
                } else {
                    vm.view.isActiveOptionAll = false;
                    vm.view.isActiveOptionIndividual = true;
                    vm.view.menuSelectAll = 'disable';
                    vm.view.menuSelectIndividual = 'enable';
                }
            } else {
                vm.view.isActiveOptionAll = false;
                vm.view.isActiveOptionIndividual = false;
                vm.view.menuSelectAll = 'disable';
                vm.view.menuSelectIndividual = 'disable';
            }
        }

        vm.isSearchEmpty = function () {
            return !OltData.requestRunning && !OltData.arrayOlts.length && OltData.isSearch;
        }

        // private method
        function checkStatusOption(status) {
            if (status) {
                vm.unselectAll();
                vm.hidePanel();
                vm.list.checkBoxEnable = false;
                return true;
            }
            return false;
        }

        function setLabelOrderText(type) {
            switch (type) {
                case 'name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function menuSelectionIsDisable(olt) {
            if (vm.view.isActiveOptionAll || vm.view.isActiveOptionIndividual) {
                olt.selected = !olt.selected
                vm.addAndRemoveItem(olt);
                return false;
            }
            return true;
        }

        function initialize() {
            vm.orderSelected = 'id';
            setLabelOrderText('id');
        }
        initialize();
    }
})();